
import { jsPDF } from "jspdf";

/**
 * Converts an image file to a single-page PDF blob.
 * @param {File} file - The image file to convert.
 * @returns {Promise<Blob>} The generated PDF as a Blob.
 */
export const convertImageToPdf = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const imgData = event.target.result;
                const img = new Image();

                img.onload = () => {
                    const doc = new jsPDF();

                    // Get page dimensions
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    // Calculate image dimensions to fit within page with margins
                    const margin = 10;
                    const maxWidth = pageWidth - (margin * 2);
                    const maxHeight = pageHeight - (margin * 2);

                    let imgWidth = img.width;
                    let imgHeight = img.height;

                    // Calculate scale factor to fit
                    const widthScale = maxWidth / imgWidth;
                    const heightScale = maxHeight / imgHeight;
                    const scale = Math.min(widthScale, heightScale, 1); // Ensure we don't scale up if smaller

                    const finalWidth = imgWidth * scale;
                    const finalHeight = imgHeight * scale;

                    // Center the image
                    const x = (pageWidth - finalWidth) / 2;
                    const y = (pageHeight - finalHeight) / 2;

                    // Add image to PDF
                    // Format 'JPEG', 'PNG', etc. derived from file type or let jsPDF handle it?
                    // jsPDF detects type if data url provided mainly for jpeg/png.
                    const format = file.type === 'image/png' ? 'PNG' : 'JPEG';

                    doc.addImage(imgData, format, x, y, finalWidth, finalHeight);

                    const pdfBlob = doc.output("blob");
                    resolve(pdfBlob);
                };

                img.onerror = (err) => reject(new Error("Failed to load image: " + err));
                img.src = imgData;

            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};
